module.exports = __webpack_public_path__ + "static/small_editor-4914fd3e2ef5c8df1b173529bb801a84.svg";